export default "__VITE_ASSET__5c10ea03__"